import type {State} from 'src/reducers';

import type {
  Template,
  Templates,
  SchedulerTemplatesStateQueryParams,
} from 'src/types/scheduler/templates';


export const selectIndividualTemplates = (state: State): Templates => {
  return state.scheduler.templates.individualTemplates.data || [];
};

export const selectIndividualTemplatesTotalCount = (state: State): number => {
  return state.scheduler.templates.individualTemplates.totalCount || 0;
};

export const selectIndividualTemplatesQueryParams = (
  state: State,
): SchedulerTemplatesStateQueryParams => {
  return state.scheduler.templates.individualTemplates.queryParams || {};
};

export const selectTeamTemplates = (state: State): Templates => {
  return state.scheduler.templates.teamTemplates.data || [];
};

export const selectTeamTemplatesQueryParams = (
  state: State,
): SchedulerTemplatesStateQueryParams => {
  return state.scheduler.templates.teamTemplates.queryParams || {};
};

export const selectTeamTemplatesTotalCount = (state: State): number => {
  return state.scheduler.templates.teamTemplates.totalCount || 0;
};

export const selectAllTemplates = (state: State): Templates => {
  const {individualTemplates, teamTemplates} = state.scheduler.templates;
  return [...individualTemplates.data, ...teamTemplates.data];
};

export const selectTemplateById = (
  state: State,
  templateId: string,
): Template | undefined => {
  return selectAllTemplates(state).find(
    (template) => template.id === templateId,
  );
};
